<app-modal-form>
  @if (component === 'leaflet-draw-parcela') {
    <app-modal-leaflet-draw
      form
      (closeModal)="drawer.close()"></app-modal-leaflet-draw>
  }
  <mat-drawer-container id="content" [hasBackdrop]="true" plainContent>
    <mat-drawer
      id="GISDrawer"
      #drawer
      mode="over"
      position="end"
      [opened]="opened_menu_filtros"
      [scrollLeft]="true"
      (closed)="onCloseDrawer()">
      <app-modal-gis></app-modal-gis>
    </mat-drawer>
    <mat-drawer-content>
      @if (on4sig && fullRendered) {
        <div class="content">
          <app-visorgis></app-visorgis>
        </div>
      }
    </mat-drawer-content>
  </mat-drawer-container>
</app-modal-form>
